import React, {Component} from "react";
import {bindActionCreators} from "redux";
import {Link} from "react-router-dom";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import CloudFlyerAPI from "../../../api/CloudFlyerAPI";
import {receiveError} from "../../../api/http";

import prettysize from "../../../../src/utils";

import moment from "moment";
import {
    Modal,
    Table,
    Divider,
    DatePicker,
    Checkbox,
    Button,
    Tooltip,
    Select,
    Pagination,
    Spin, message,
} from "antd";
import queryString from "query-string";
import CreateTransferCostrReport from "./TransferCostReport/eachRepoert";
import TransferCostDetail from "./TransferCostDetail/transferCostDetail";

import {refresh_rm} from "../../../actions/auth";

import "./usageDetail.scss";
import {data} from "jquery";

const dateFormat = "YYYY/MM/DD";
const {RangePicker} = DatePicker;

class UserUsageDeatil extends Component {
    constructor(props) {
        super(props);

        this.state = {
            transferSummary: [],
            transferHistory: [],
            startDate: moment().subtract(1, "months"),
            endDate: moment(),
            directions: [],
            accountId: null,
            accountName: "",
            userId: null,
            usersList: [],
            loading: false,
            historyLoading: false,
            pageSize: 50,
            page: 1,
            total: 0,

            transferRegionSummary: [],
            modalVisible: false,
            regionLoding: false,
            accountList: [],
        };
        this.onChangeAccount = this.onChangeAccount.bind(this);
    }

    componentDidMount() {
        const {id, name, userId} = queryString.parse(this.props.location.search);

        if (userId === undefined) {
            this.setState({
                accountId: id,
                accountName: name
            });
        } else {
            this.setState({
                accountId: id,
                accountName: name,
                userId: userId,
            });
        }
        CloudFlyerAPI.user_account
            .getUsersByAccount(id, 100, 1)
            .then(({data}) => {
                this.setState({
                    usersList: data.data,
                    loading: false,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });

        this.props.refresh_rm();


        CloudFlyerAPI.user_account
            .fetchAllAccounts(0, 0, null)
            .then(({data}) => {
                console.log(data, "accountList")
                this.setState({
                    accountList: data.data,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    }

    onChangeAccount(value) {
        let accountName = "";
        for(let i =0; i < this.state.accountList.length; i++){
            if(this.state.accountList[i].id === value){
                accountName = this.state.accountList[i].name;
            }
        }
        this.setState({
            accountId: value,
            accountName: accountName
        });
        console.log(`selected ${value}`);
        console.log(`accountName ${accountName}`);
        this.props.history.push("/usageDetail/?id=" + value + "&name=" + accountName);
        window.location.reload();
    }
    componentWillReceiveProps(props) {
    }

    onPeriodChange = (value) => {
        let date = [];
        date.push(value);

        let startDate = value[0];
        let endDate = value[1];

        this.setState({
            startDate: startDate,
            endDate: endDate,
        });
    };

    onPageChange = (page) => {
        this.setState({page: page, historyLoading: true});
        let filters = {
            startDate: this.state.startDate._d,
            endDate: this.state.endDate._d,
            accountId: this.state.accountId,
            userId: this.state.userId,
            sources: this.state.directions,
        };

        CloudFlyerAPI.user_account
            .getTransferHistory(filters, this.state.pageSize, page)
            .then(({data}) => {
                this.setState({
                    transferHistory: data.data,
                    loading: false,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                    historyLoading: false,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });
    };

    onDirectionChange = (value) => {
        this.setState({
            directions: value,
        });
    };

    onFilter = () => {
        this.setState({
            loading: true,
            historyLoading: true,
        });
        let filters = {
            startDate: this.state.startDate._d,
            endDate: this.state.endDate._d,
            accountId: this.state.accountId,
            userId: this.state.userId,
            sources: this.state.directions,
        };

        CloudFlyerAPI.user_account
            .getTransferSummary(filters)
            .then(({data}) => {
                this.setState({
                    transferSummary: data,
                    loading: false,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });

        CloudFlyerAPI.user_account
            .getTransferHistory(filters, this.state.pageSize, 1)
            .then(({data}) => {
                this.setState({
                    transferHistory: data.data,
                    historyLoading: false,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });
    };

    onSummaryRowClick = (source) => {
        this.setState({
            modalVisible: true,
            regionLoding: true,
            transferRegionSummary: [],
        });

        let filters = {
            startDate: this.state.startDate._d,
            endDate: this.state.endDate._d,
            accountId: this.state.accountId,
            userId: this.state.userId,
            sources: this.state.directions,
            source: source,
        };

        CloudFlyerAPI.user_account
            .getTransferRegionSummary(filters)
            .then(({data}) => {
                this.setState({
                    transferRegionSummary: data,
                    regionLoding: false,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });
    };

    onModalClose = () => {
        console.log("close");
        this.setState({
            modalVisible: false,
        });
    };

    on_user_change = (value) => {
        this.setState({
            userId: value,
        });
    };
    downloadTransferHistory = () => {

        var body = {
            "startDate": this.state.startDate,
            "endDate": this.state.endDate,
            "accountId": this.state.accountId,
            "userId": this.state.userId,
            "transferType": 0,
            "transferStatus": 0,
            "sources": this.state.directions
        }

        console.log(this.state.directions)
        CloudFlyerAPI.user_account
            .downloadTransferHistory(body)
            .then(({data}) => {
                console.log(data);

                var startDate = new Date(this.state.startDate);
                var endDate = new Date(this.state.endDate);
                var encodedUri = encodeURI( "data:text/csv;charset=utf-8,"+data);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", "transfer-history-"+startDate.getFullYear()+"."+startDate.getMonth()+"."+startDate.getDate()+"-"+endDate.getFullYear()+"."+endDate.getMonth()+"."+endDate.getDate()+".csv");
                document.body.appendChild(link); // Required for FF

                link.click();
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
            });

    };

    render() {
        let directions = new Map();
        directions.set(1, "AWS to Wasabi");
        directions.set(2, "Wasabi to Wasabi");
        directions.set(4, "Azure to Wasabi");
        directions.set(8, "S3 Generic to Wasabi");
        directions.set(16, "Google to Wasabi");

        let transferTypes = new Map();
        transferTypes.set(1, "Migration");
        transferTypes.set(2, "Replication");

        const {Option} = Select;

        const transferCostTableHeader = (
            <ul>
                <li>Direction</li>
                <li>Total Transfer</li>
                <li>Total Cost</li>
                <li>Detail</li>
            </ul>
        );

        const transferCostReport = this.state.loading ? (
            <Spin
                size="small"
                tip="Loading..."
                style={{padding: "1% 50%", margin: "0 auto"}}
            />
        ) : (
            this.state?.transferSummary?.map((data, index) => {
                return (
                    <div>
                        <Divider/>
                        <CreateTransferCostrReport
                            key={index}
                            source={directions.get(data.source)}
                            totalTransfer={prettysize(data.transferredSize)}
                            totalCost={data.cost}
                            onRowClick={() => this.onSummaryRowClick(data.source)}
                        />
                    </div>
                );
            })
        );

        const columns = [
            {
                title: "User",
                dataIndex: "username",
                key: "username",
                ellipsis: {
                    showTitle: false,
                },
                render: (username) => (
                    <Tooltip placement="topLeft" title={username}>
                        {username}
                    </Tooltip>
                ),
                width: 150,
            },
            {
                title: "Direction",
                dataIndex: "direction",
                key: "direction",
                width: 130,
            },
            {
                title: "Source Bucket",
                dataIndex: "source",
                key: "source",
                ellipsis: {
                    showTitle: false,
                },
                render: (source) => (
                    <Tooltip placement="topLeft" title={source}>
                        {source}
                    </Tooltip>
                ),
                width: 130,
            },
            {
                title: "Destination Bucket",
                dataIndex: "destination",
                key: "destination",
                ellipsis: {
                    showTitle: false,
                },
                render: (destination) => (
                    <Tooltip placement="topLeft" title={destination}>
                        {destination}
                    </Tooltip>
                ),
                width: 130,
            },
            {
                title: "Total Size",
                dataIndex: "totalSize",
                key: "totalSize",
                width: 120,
            },
            {
                title: "Transferred size",
                dataIndex: "transferredSize",
                key: "transferredSize",
                width: 130,
            },
            {
                title: "Date",
                dataIndex: "date",
                key: "date",
                width: 100,
            },
            {
                title: "Total",
                dataIndex: "total",
                key: "total",
                width: 80,
            },
            {
                title: "Transferred",
                dataIndex: "transferred",
                key: "transferred",
                width: 100,
            },
            {
                title: "Cost",
                dataIndex: "transferredCost",
                key: "transferredCost",
                width: 110,
            },
            {
                title: "Transfer Type",
                dataIndex: "transferType",
                key: "transferType",
                width: 100,
            },
        ];

        let data = this.state?.transferHistory?.map((t, index) => {
            return {
                key: t.id,
                username: t.username,
                direction: directions.get(t.source),
                source: t.sourceBucket,
                destination: t.destinationBucket,
                totalSize: prettysize(t.totalSize),
                transferredSize: prettysize(t.transferredSize),
                date: moment
                    .parseZone(t.requestDate)
                    .local()
                    .format("MM/DD/YYYY"),
                total: t.total,
                transferred: t.transferred,
                transferredCost: "$" + t.transferredCost,
                transferType: transferTypes.get(t.transferType),
            };
        });

        return (
            <div className="usage-detail-wrapper">
                <Modal
                    visible={this.state.modalVisible}
                    title="Transfer and Cost Report"
                    onCancel={this.onModalClose}
                    closable={true}
                    footer={null}
                    width={1000}
                    height={600}
                >
                    <TransferCostDetail
                        listData={this.state.transferRegionSummary}
                        loading={this.state.regionLoding}
                    />
                </Modal>

                <div className="filter-wrapper">
                    <div className="header">
                        <div className="user-dropdown">
                            <h3>Account Name:</h3>
                            <Select
                                showSearch
                                style={{width: 200}}
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                value={this.state.accountId}
                                defaultValue={this.state.accountName}
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                }
                                onChange={this.onChangeAccount}
                            >
                                {
                                    this.state.accountList.map((data, index) => (
                                        <Option key={index} value={data.id}>{data.name}</Option>
                                    ))
                                }
                            </Select>
                        </div>
                        <div className="user-dropdown">
                            <h3>User:</h3>
                            <Select
                                onSelect={this.on_user_change}
                                value={this.state.userId}
                                defaultValue={this.state.userId}
                                style={{width: 220}}
                            >
                                <Option value={null}>ALL</Option>
                                {this.state.usersList?.map((user, index) => (
                                    <Option value={user.id} key={user.id}>
                                        {user.username}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>
                    <div className="filter-content">
                        <div className="period-wrapper">
                            <h4 className="period-header">
                                <span>1</span>Period:
                            </h4>
                            <div className="period-content">
                                <div className="start-date">
                                    <h4>Start Date ~ End Date</h4>
                                    <RangePicker
                                        width={400}
                                        onChange={(value) => this.onPeriodChange(value)}
                                        defaultValue={[this.state.startDate, this.state.endDate]}
                                        format={dateFormat}
                                    />
                                </div>
                            </div>
                        </div>
                        <Divider type="vertical"/>
                        <div className="source-wrapper">
                            <h4 className="source-header">
                                <span>2</span>Direction:
                            </h4>
                            <Checkbox.Group
                                style={{width: "100%"}}
                                onChange={this.onDirectionChange}
                            >
                                <div className="source-content">
                                    <div className="left">
                                        <Checkbox value={1}>AWS to Wasabi</Checkbox>
                                        <Checkbox value={4}>Azure to Wasabi</Checkbox>
                                    </div>
                                    <div className="right">
                                        <Checkbox value={2}>Wasabi to Wasabi</Checkbox>
                                        <Checkbox value={8}>Generic S3 to Wasabi</Checkbox>
                                    </div>
                                </div>
                            </Checkbox.Group>
                        </div>
                    </div>
                    <Button
                        className="filter-usage-btn"
                        type="primary"
                        onClick={this.onFilter}
                    >
                        Filter
                    </Button>
                </div>

                <div className="total-transfer-cost">
                    <div className="header">
                        <h3 className="title-left">Total Transfer/Cost Report</h3>
                        <h3 className="title-right"></h3>
                    </div>
                    <div className="table-header">{transferCostTableHeader}</div>
                    <div>{transferCostReport}</div>
                </div>

                <div className="recent-transfer-wrapper">
                    <div className="header">
                        <h3 className="title-left">Transfer History</h3>
                        {data.length > 0 &&
                            <div className="btn-wrapper">
                                <a href='#' className="ant-btn filter-usage-btn ant-btn-primary btn-style" onClick={this.downloadTransferHistory}>Download Report</a></div>
                        }

                    </div>
                    <div>
                        <Table
                            loading={this.state.historyLoading}
                            columns={columns}
                            dataSource={data}
                            pagination={{
                                onChange: this.onPageChange,
                                total: this.state.total,
                                current: this.state.page,
                                showTotal: (total, range) =>
                                    `${range[0]}-${range[1]} of ${total} items`,
                                pageSize: this.state.pageSize,
                            }}
                            scroll={{y: 500}}
                        />
                    </div>
                    <Divider/>
                </div>
            </div>
        );
    }
}

export default withRouter(
    connect(
        () => ({}),
        (dispatch) => bindActionCreators({refresh_rm}, dispatch)
    )(UserUsageDeatil)
);
